import axios from 'axios'
import type { AxiosInstance } from 'axios'

import useCdcProps from '@/composables/useCdcProps'
import useExternalUrlCallbacks from '@/composables/useExternalUrlCallbacks'

import type { ContextStore } from '@/stores/context'

const { reloadPage } = useExternalUrlCallbacks()
export default class AppService {
  mboApiV1: AxiosInstance
  context: ContextStore

  constructor(appContext: ContextStore) {
    this.context = appContext
    this.mboApiV1 = axios.create({
      baseURL: import.meta.env.VITE_NEST_API_URL,
      headers: {
        Authorization: `Bearer ${
          appContext.mboToken || (window as any)?.xprops?.context?.mbo_token
        }`,
      },
    })
    this.#setTokenValidationInterceptor()
  }

  #setTokenValidationInterceptor() {
    const refreshToken = (request: any) => {
      try {
        this.#handleRefreshToken()
        return request
      } catch (err) {
        reloadPage()
      }
    }

    this.mboApiV1.interceptors.request.use(refreshToken, (error) => {
      return Promise.reject(error)
    })
  }

  #handleRefreshToken() {
    const { xprops } = useCdcProps()
    const refreshToken = xprops?.handleRefreshToken
    const refreshUrl = this.context.refreshUrl
    return refreshUrl ? refreshToken(refreshUrl) : true
  }
}
